import * as React from 'react';

import { __t, applyTranslations } from 'utils/language';
import navigate from 'libs/router/navigate';

import BasicHeaderWithLogo from 'components/BasicHeaderWithLogo';
import Footer from 'components/footer/Footer';
import UnsupportedBrowserBanner from 'components/banners/unsupported-browser-banner/UnsupportedBrowserBanner';

applyTranslations(require('./i18n/fatal-error-layout.i18n.json'));

class FatalErrorLayout extends React.PureComponent {
  componentDidMount() {
    navigate.shutdown(); // to stop handling links in the footer and force page reload
  }

  handleReload = () => {
    navigate.reload();
  };

  renderLayout(inner: React.ReactNode): React.ReactNode {
    return (
      <section className="layout-page layout-page--fatal">
        {inner}
      </section>
    );
  }

  render(): React.ReactNode {
    return (
      <section>
        <UnsupportedBrowserBanner />
        <BasicHeaderWithLogo />
        {
          this.renderLayout(
            <section
              className="fatal-error"
              data-qa="fatal-error"
            >
              <div className="fatal-error__message">
                <div>
                  {__t('fatal_error_layout.message_line_1')}
                </div>
                <div>
                  {`${__t('fatal_error_layout.message_line_2')} `}
                  <a
                    href="mailto:hello@collabary.com"
                    className="fatal-error__link"
                  >
                    hello@collabary.com
                  </a>.
                </div>
              </div>
              <div className="fatal-error__action">
                <button
                  type="button"
                  className="fatal-error__button"
                  onClick={this.handleReload}
                >
                  {__t('fatal_error_layout.button_reload')}
                </button>
              </div>
            </section>
          )
        }
        <Footer />
      </section>
    );
  }
}

export default FatalErrorLayout;
